import { useEffect, useState, useRef, useCallback } from "react";
import "./style.css";

const NAMES = [
  "Hana",
  "Dede",
  "Dhika",
  "Budi",
  "Rafly",
  "Rizky",
  "Fikri",
  "Zikri",
  "Fahdi",
  "Siti",
  "Eko",
  "Andi",
  "Dewi",
  "Anggi",
  "Agus",
  "Putri",
  "Joko",
  "Fitri",
  "Dian",
  "Dwi",
  "Nur",
  "Dewi",
  "Tri",
  "Sri",
  "Putri",
  "Eka",
  "Sari",
  "Ayu",
  "Wahyu",
  "Ika",
  "Fitri",
  "Ratna",
  "Andi",
  "Agung",
  "Ahmad",
  "Kurniawan",
  "Ilham",
  "Budi",
  "Adi",
  "Nurul",
  "Putra",
  "Ani",
  "Arif",
  "Puspita",
  "Ari",
  "Indra",
  "Dyah",
  "Rizki",
  "Maria",
  "Ratih",
  "Pratiwi",
  "Kartika",
  "Wulandari",
  "Fajar",
  "Bayu",
  "Lestari",
  "Anita",
  "Muhamad",
  "Kusuma",
  "Rahmawati",
  "Fitria",
  "Retno",
  "Kurnia",
  "Novita",
  "Aditya",
  "Ria",
  "Nugroho",
  "Handayani",
  "Rahayu",
  "Yunita",
  "Rina",
  "Ade",
  "Widya",
  "Intan",
  "Diah",
  "Agustina",
  "Abdul",
  "Setiawan",
  "Rini",
  "Wahyuni",
  "Yulia",
  "Maya",
  "Puji",
  "Utami",
  "Amalia",
  "Dina",
  "Devi",
  "Citra",
  "Arief",
  "Munaroh",
  "Bagus",
  "Hidayat",
  "Hendra",
  "Eva",
  "Endah",
  "Indah",
];

const PRODUCT_NEW = [
  // Dedicated Server (Group ID: 38) - Sering muncul
  { name: "Single Intel Xeon E3-1270v6 - 4 cores - 3,8 GHz (Amsterdam)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Dual Intel Xeon E5-2620v4 - 8 cores - 2,1 GHz (Amsterdam)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Single Intel Xeon E3-1270v6 - 4 cores - 3,8 GHz (Hongkong)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Dual Intel Xeon E5-2620v4 - 8 cores - 2,1 GHz (Hongkong)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Single Intel Xeon E3-1270v6 - 4 cores - 3,8 GHz (Singapore)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Dual Intel Xeon E5-2620v4 - 8 cores - 2,1 GHz (Singapore)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Single Intel Xeon E-2274G - 4 cores - 4 GHz (Sydney)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Dual Intel Xeon E5-2620v4 - 8 cores - 2,1 GHz (Sydney)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Single Intel Xeon E3-1270v6 - 4 cores - 3,8 GHz (London)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Dual Intel Xeon E5-2620v4 - 8 cores - 2,1 GHz (London)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Intel® Xeon® E-2278G - 8 Core - 3,4 GHz (Bogor)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "AMD EPYC™ 7402P - 24 Core - 2,8 GHz (Bogor)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "AMD EPYC™ 9554P - 64 Core - 3,1 GHz (Bogor)", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Dual Intel Xeon E5-2620v4 - 8 cores - 2,1 GHz (Plaza Kuningan) Paket A", groupId: "38", groupName: "Dedicated Server", weight: 15 },
  { name: "Dual Intel Xeon E5-2620v4 - 8 cores - 2,1 GHz (Plaza Kuningan) Paket B", groupId: "38", groupName: "Dedicated Server", weight: 15 },

  // Cloud VPS Corporate (Group ID: 26) - Muncul tapi tidak sesering
  { name: "VC1", groupId: "26", groupName: "Cloud VPS Corporate", weight: 8 },
  { name: "VC2", groupId: "26", groupName: "Cloud VPS Corporate", weight: 8 },
  { name: "VC4", groupId: "26", groupName: "Cloud VPS Corporate", weight: 8 },
  { name: "VC8", groupId: "26", groupName: "Cloud VPS Corporate", weight: 8 },
  { name: "VC16", groupId: "26", groupName: "Cloud VPS Corporate", weight: 8 },
  { name: "VC32", groupId: "26", groupName: "Cloud VPS Corporate", weight: 8 },
  { name: "VC64", groupId: "26", groupName: "Cloud VPS Corporate", weight: 8 },

  // Cloud VPS Corporate - JKT2 (Group ID: 29)
  { name: "VC1 (SouthJKT-2)", groupId: "29", groupName: "Cloud VPS Corporate - JKT2", weight: 8 },
  { name: "VC2 (SouthJKT-2)", groupId: "29", groupName: "Cloud VPS Corporate - JKT2", weight: 8 },
  { name: "VC4 (SouthJKT-2)", groupId: "29", groupName: "Cloud VPS Corporate - JKT2", weight: 8 },
  { name: "VC8 (SouthJKT-2)", groupId: "29", groupName: "Cloud VPS Corporate - JKT2", weight: 8 },
  { name: "VC16 (SouthJKT-2)", groupId: "29", groupName: "Cloud VPS Corporate - JKT2", weight: 8 },
  { name: "VC32 (SouthJKT-2)", groupId: "29", groupName: "Cloud VPS Corporate - JKT2", weight: 8 },
  { name: "VC64 (SouthJKT-2)", groupId: "29", groupName: "Cloud VPS Corporate - JKT2", weight: 8 },

  // Cloud VPS Corporate - WestJavaBDG-1 (Group ID: 31)
  { name: "VC1 (WestJavaBDG-1)", groupId: "31", groupName: "Cloud VPS Corporate - WestJavaBDG-1", weight: 8 },
  { name: "VC2 (WestJavaBDG-1)", groupId: "31", groupName: "Cloud VPS Corporate - WestJavaBDG-1", weight: 8 },
  { name: "VC4 (WestJavaBDG-1)", groupId: "31", groupName: "Cloud VPS Corporate - WestJavaBDG-1", weight: 8 },
  { name: "VC8 (WestJavaBDG-1)", groupId: "31", groupName: "Cloud VPS Corporate - WestJavaBDG-1", weight: 8 },
  { name: "VC16 (WestJavaBDG-1)", groupId: "31", groupName: "Cloud VPS Corporate - WestJavaBDG-1", weight: 8 },
  { name: "VC32 (WestJavaBDG-1)", groupId: "31", groupName: "Cloud VPS Corporate - WestJavaBDG-1", weight: 8 },
  { name: "VC64 (WestJavaBDG-1)", groupId: "31", groupName: "Cloud VPS Corporate - WestJavaBDG-1", weight: 8 },

  // Leased To Owned Dedicated Bare Metal Server (Group ID: 27)
  { name: "Dell R620 CSO LTO Series (24 Months)", groupId: "27", groupName: "Leased To Owned Dedicated Bare Metal Server", weight: 5 },
  { name: "Dell R620 CSO LTO Series (12 Months)", groupId: "27", groupName: "Leased To Owned Dedicated Bare Metal Server", weight: 5 },
  { name: "Dell R720 CSO LTO Series (24 Months)", groupId: "27", groupName: "Leased To Owned Dedicated Bare Metal Server", weight: 5 },
  { name: "Dell R720 CSO LTO Series (12 Months)", groupId: "27", groupName: "Leased To Owned Dedicated Bare Metal Server", weight: 5 },
  { name: "Dell R630 CSO LTO Series (24 Months)", groupId: "27", groupName: "Leased To Owned Dedicated Bare Metal Server", weight: 5 },
  { name: "Dell R630 CSO LTO Series (12 Months)", groupId: "27", groupName: "Leased To Owned Dedicated Bare Metal Server", weight: 5 },

  // Colocation Server (Group ID: 4) - Lebih jarang muncul
  { name: "1U Mikrotik/Switch (100W, 1 Power Plug)", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "1U Mikrotik/Switch (200W, 1 Power Plug)", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "1U OTB", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "1U Colocation", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "2U Colocation", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "4U Colocation", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "Mac Mini / INTEL NUC / Raspberry PI Colocation", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "Mac Mini / INTEL NUC / Raspberry PI Colocation No Bandwidth", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "1U Colocation No Bandwidth", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "2U Colocation No Bandwidth", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "4U Colocation No Bandwidth", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "8U Colocation No Bandwidth", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "20U Rack (1/2 Rack) No Bandwidth", groupId: "4", groupName: "Colocation Server", weight: 3 },
  { name: "42U Rack (Full Rack) No Bandwidth", groupId: "4", groupName: "Colocation Server", weight: 3 },
];

const HOSTING_DURATIONS = [
  { duration: "1 Bulan", weight: 20 },
  { duration: "3 Bulan", weight: 20 },
  { duration: "6 Bulan", weight: 20 },
  { duration: "12 Bulan", weight: 5 },
];

const TIMES = [
  { label: "1 menit lalu", value: 1 },
  { label: "2 menit lalu", value: 2 },
  { label: "3 menit lalu", value: 3 },
  { label: "4 menit lalu", value: 4 },
  { label: "5 menit lalu", value: 5 },
  { label: "6 menit lalu", value: 6 },
  { label: "7 menit lalu", value: 7 },
  { label: "8 menit lalu", value: 8 },
  { label: "9 menit lalu", value: 9 },
  { label: "10 menit lalu", value: 10 },
  { label: "11 menit lalu", value: 11 },
  { label: "12 menit lalu", value: 12 },
  { label: "13 menit lalu", value: 13 },
  { label: "14 menit lalu", value: 14 },
  { label: "15 menit lalu", value: 15 },
  { label: "16 menit lalu", value: 16 },
  { label: "17 menit lalu", value: 17 },
  { label: "18 menit lalu", value: 18 },
  { label: "19 menit lalu", value: 19 },
  { label: "20 menit lalu", value: 20 },
  { label: "30 menit lalu", value: 30 },
  { label: "1 jam lalu", value: 60 },
];

const ICON_HOSTING =
  "https://qwords.com/wp-content/themes/qwords/assets/images/icons/menu/cloud%20hosting/High%20Performance%20Bisnis.webp";


function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function getRandomDelay(min = 10000, max = 30000) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}



function getRandomWithWeightGeneric(items, property) {
  const totalWeight = items.reduce((sum, item) => sum + item.weight, 0);
  let random = Math.random() * totalWeight;
  
  for (const item of items) {
    if (random < item.weight) {
      return item[property];
    }
    random -= item.weight;
  }
  
  return items[0][property];
}


const PopupRandomBuy = () => {
  const [show, setShow] = useState(false);
  const [randomData, setRandomData] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  // Use refs for timeouts to avoid dependency issues
  const timeoutShowRef = useRef(null);
  const timeoutHideRef = useRef(null);
  const isFadingOutRef = useRef(false);
  const isModalActiveRef = useRef(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to prevent infinite loop

  const showRandomModal = useCallback(() => {
    // Prevent showing if already fading out or modal is active
    if (isFadingOutRef.current || isModalActiveRef.current) return;
    
    isModalActiveRef.current = true;
    
    // Tentukan produk dan durasi
    const selectedProduct = getRandomWithWeightGeneric(PRODUCT_NEW, 'name');
    const hostingDuration = getRandomWithWeightGeneric(HOSTING_DURATIONS, 'duration');
      
        const data = {
          name: getRandom(NAMES),
          time: getRandom(TIMES).label,
      product: selectedProduct,
      productDuration: hostingDuration,
      productGroup: selectedProduct.groupName,
      icon: ICON_HOSTING,
    };
        setRandomData(data);
        setShow(true);

    // Hide modal after exactly 4 seconds with fade effect
    const hideTimeout = setTimeout(() => {
      // console.log('Auto close triggered after 4 seconds');
      setIsFadingOut(true);
      isFadingOutRef.current = true;
      // Wait for fade animation to complete before hiding
      setTimeout(() => {
        // console.log('Auto close completed');
        setShow(false);
        setIsFadingOut(false);
        isFadingOutRef.current = false;
        isModalActiveRef.current = false;
        
        // Show next modal after random delay (10-30 seconds)
        const nextShowTimeout = setTimeout(showRandomModal, getRandomDelay(10000, 30000));
        timeoutShowRef.current = nextShowTimeout;
      }, 500); // Wait for 0.5s fade animation
    }, 4000); // 4 seconds auto close
    timeoutHideRef.current = hideTimeout;
  }, []); // Empty dependency array to prevent infinite loop

  useEffect(() => {
    // Start first modal after random delay (10-30 seconds)
    const firstShowTimeout = setTimeout(showRandomModal, getRandomDelay(10000, 30000));
    timeoutShowRef.current = firstShowTimeout;
    
    return () => {
      if (timeoutShowRef.current) clearTimeout(timeoutShowRef.current);
      if (timeoutHideRef.current) clearTimeout(timeoutHideRef.current);
    };
  }, [showRandomModal]);

  // Debug function to show popup manually
  const handleDebugShowPopup = () => {
    // Clear any existing timeouts first
    if (timeoutHideRef.current) clearTimeout(timeoutHideRef.current);
    if (timeoutShowRef.current) clearTimeout(timeoutShowRef.current);
    
    // Tentukan produk dan durasi
    const selectedProduct = getRandomWithWeightGeneric(PRODUCT_NEW, 'name');
    const hostingDuration = getRandomWithWeightGeneric(HOSTING_DURATIONS, 'duration');
    
    const data = {
      name: getRandom(NAMES),
      time: getRandom(TIMES).label,
      product: selectedProduct,
      productDuration: hostingDuration,
      productGroup: selectedProduct.groupName,
      icon: ICON_HOSTING,
    };
    
    setRandomData(data);
    setShow(true);
    
    // Auto close after 4 seconds for debug
    const debugHideTimeout = setTimeout(() => {
      // console.log('Debug popup auto close triggered');
      setIsFadingOut(true);
      setTimeout(() => {
        // console.log('Debug popup auto close completed');
        setShow(false);
        setIsFadingOut(false);
        isModalActiveRef.current = false;
      }, 500);
    }, 4000);
    timeoutHideRef.current = debugHideTimeout;
  };

  const handleCloseModal = () => {
    // Prevent multiple calls
    if (isFadingOut) return;
    
    setIsFadingOut(true);
    // Clear any existing timeouts
    if (timeoutHideRef.current) clearTimeout(timeoutHideRef.current);
    if (timeoutShowRef.current) clearTimeout(timeoutShowRef.current);
    
    // Wait for fade animation to complete before hiding
    setTimeout(() => {
      setShow(false);
      setIsFadingOut(false);
      isModalActiveRef.current = false;
      
      // Show next modal after random delay (10-30 seconds)
      const nextShowTimeout = setTimeout(() => {
        // Tentukan produk dan durasi
        const selectedProduct = getRandomWithWeightGeneric(PRODUCT_NEW, 'name');
        const hostingDuration = getRandomWithWeightGeneric(HOSTING_DURATIONS, 'duration');
        
        const data = {
          name: getRandom(NAMES),
          time: getRandom(TIMES).label,
          product: selectedProduct,
          productDuration: hostingDuration,
          productGroup: selectedProduct.groupName,
          icon: ICON_HOSTING,
        };
        setRandomData(data);
        setShow(true);

        // Auto close after 4 seconds
        const hideTimeout = setTimeout(() => {
          setIsFadingOut(true);
          setTimeout(() => {
            setShow(false);
            setIsFadingOut(false);
            isModalActiveRef.current = false;
          }, 500);
        }, 4000);
        timeoutHideRef.current = hideTimeout;
      }, getRandomDelay(10000, 30000));
      timeoutShowRef.current = nextShowTimeout;
    }, 500); // Wait for 0.5s fade animation
  };

  return (
    <>
      {/* Debug Button */}
      {/* <div style={{ 
        position: 'fixed', 
        top: '10px', 
        right: '10px', 
        zIndex: 10000,
        display: 'flex',
        gap: '10px'
      }}>
        <button 
          onClick={handleDebugShowPopup}
          style={{
            background: '#007bff',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold'
          }}
        >
          🚀 Test Popup
        </button>
      </div> */}

      {show && (
        <div className={`modal-random-buy ${isMobile ? 'mobile' : 'desktop'} ${isFadingOut ? 'fade-out' : ''}`}>
          <button className="modal-close-btn" onClick={handleCloseModal} aria-label="Tutup">×</button>
          <div className="modal-time">
            {randomData.time}
          </div>
          <div className="modal-content">
            <div className="modal-label-badge">
              Server Terjual
            </div>
            <div className="modal-name">
              {randomData.name}
              <span className="modal-subtext">
                baru saja membeli
              </span>
            </div>
              <div className="modal-product">
              <div className="modal-product-details">
                <span className="modal-product-value">
                  {(() => {
                    if (randomData.product && randomData.product.name) {
                      return randomData.product.name;
                    } else if (randomData.product && typeof randomData.product === 'string') {
                      return randomData.product;
                    } else {
                      return 'Server VPS';
                    }
                  })()}
                </span>
                <span className="modal-duration">
                  ({randomData.productDuration || '1 Bulan'})
                </span>
              </div>
            </div>
            <div className="modal-verified">
              Diverifikasi oleh Xendit
            </div>
          </div>
          <div className="modal-icon">
            <img
              src={randomData.icon}
              alt="icon"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PopupRandomBuy;
